import { FaRegBuilding } from 'react-icons/fa';
import { TiPlaneOutline } from 'react-icons/ti';

import styled from 'styled-components';

const Result: any = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.airportsSearch.resultItemBorder};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.airportsSearch.hover};
  }
`;

Result.info = styled.div`
  display: flex;
  flex-direction: column;
`;

Result.Title = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

Result.SubTitle = styled.p`
  font-size: 12px;
`;

Result.Code = styled.div`
  font-size: 16px;
  margin-left: auto;
  color: ${({ theme }) => theme.airportsSearch.airportCode};
`;

Result.icon = styled(TiPlaneOutline)`
  font-size: 12px;
  margin-right: 5px;
`;

Result.city = styled(FaRegBuilding)`
  font-size: 12px;
  margin-right: 5px;
`;

export default Result;
